module.exports = __webpack_public_path__ + "img/rocketpro.26f9ca03.gif";